export const elementsSettingsDefaults = {
    "text": {
        "text_size": 30,
    },
    "defaultByType": {
        "text": '',
        "select": 0,
        "color": '#000000',
    },
    "default": {
        "readonly": false,
        "text_input": "",
        "text_size": 30,
        "text_autoscale": "0",
        "text_family": 0,
        "text_align": "left",
        "text_valign": "top",
        "text_decoration": "",
        "text_style": "",
        "text_weight": "",
        "text_direction": "ltr",
        "text_color": "#000000",
        "primary_color": "#000000",
        "secondary_color": "#000000",
        "text_animation_type": "none",
        "text_newsticker_speed": 12,
        "text_newsticker_space": "none",
        "text_newsticker_space_margin": 5,
        "rssfeed_url": "",
        "separator": " * ",
        "no_spaces": false,
        "show_details": false,
        "picture_position": "0",
        "picture_size": "0",
        "picture_size_x": "",
        "picture_size_y": "",
        "renderer": "windows-media-streaming",
        "url": "",
        "iframe_url": "",
        "iframe_user": "",
        "iframe_pass": "",
        "iframe_transparent": "0",
        "loading_behavior": "load",
        "iframe_no_cache": true,
        "show_scrollbars": false,
        "youtube_url": "",
        "qrcode_url": "",
        "countdown_date": "",
        "countdown_time": "",
        "description": "",
        "layer": "",
        "language": Laravel.activeLanguage,
        "city": "",
        "esign_type": "stBoard",
        "esign_id": "",
        "esign_name": "",
        "esign_style": "",
        "esign_refresh": "60",
        "esign_transparency": "0",
        "esign_scrolling": "0",
        "scrolling": "0",
        "transparency": "0",
        "delay": "0",
        "drop_shadow": "",
        "back_transparency": "100",
        "interval": "11",
        "interval_automatic": "0",
        "loop": 1,
        "strict_mode": false,

        "display_standard_text": "unavailable",
        "dynamic": null,

        // Template only


        // Campaign only
        "duration": Laravel.default_duration,
        "duration_original": Laravel.default_duration,
        "display_runs": 1,
        "duration_type": 1,
        "transition_length": "0.4",

        "valid_from": "",
        "valid_to": "",
        "validity": {"status": "normal", "text": Lang.langGet("always valid")},
        "visual_validity": {"status": "", "text": ""},

        "width": 1920,
        "height": 1080,
        "ratio": 1920.0 / 1080.0,
        "tags": [],
        "strict_mode_usergroups": false,
        "strict_mode_tags": false,
        "dynamic_autoremove": false,
        "layers": [],

        "synchronize_playback": "0",
        "smart_loop": 0,
        "interactive": 0,

        //Publish only
        "valid_time_from": "",
        "valid_time_to": "",

        "weekdays": [],

        // All
        "alignment": "center",
        "video_volume": "100",
        "video_mute": false,

        "locked": false,
        "usergroups": [],
    }
}

export const elementsSettingsEmpty = {
    "validity": {"status": "", "text": ""},
    "visual_validity": {"status": "", "text": ""},

    "tags": [],
    "layers": [],

    "weekdays": [],

    "usergroups": [],
}


export const settingsSectionsDefinition = {
    'no_collapse': {
        "name": 1,
        "dropzone": 1,
        "synchronize_playback": 1,
        "tags": 1,
        "dynamic": 1,
        "resolution": 1,
        "elements_count": 1,
        "text_input": 1,
        "countdown_date": 1,
        "countdown_time": 1,
        "qrcode_url": 1,
        "iframe_url": 1,
        "iframe_user": 1,
        "iframe_pass": 1,
        "iframe_transparent": 1,
        "iframe_no_cache": 1,
        "show_scrollbars": 1,
        "youtube_url": 1,
        "primary_color": 1,
        "layer": 1,
        "alternative_type": 1,
        "alternative_id": 1,
        "esign_type": 1,
        "esign_id": 1,
        "esign_name": 1,
        "esign_style": 1,
        "esign_refresh": 1,
        "esign_transparency": 1,
        "esign_scrolling": 1,
        "rssfeed_url": 1,
        "separator": 1,
        "no_spaces": 1,
        "show_details": 1,
        "stretch": 1,
        "alignment": 1,
        "locked_ratio": 1,
        "video_volume": 1,
        "video_mute": 1,
        "url": 1,
        "renderer": 1,
        "interval_automatic": 1,
        "interval": 1,
        'page_from': 1,
        'page_to': 1,
        "language": 1,
        "city": 1,
        "rss_speed": 1,
        "rss_animation_type": 1,
        "rss_newsticker_space": 1,
        "rss_newsticker_space_margin": 1,
        "active_layer": 1,
    },
    'user': {
        "locked": 1,
        "usergroups": 1,
        "strict_mode": 1,
        "layers": 1,
        "width": 1,
        "height": 1,
        "ratio": 1,
        "elementLeft": 1,
        "elementTop": 1,
        "elementWidth": 1,
        "elementHeight": 1,
        "screens": 1,
        "screengroups": 1,
    },
    'extended': {
        "secondary_color": 1,
        "back_transparency": 1,
        "text_direction": 1,
        "transparency": 1,
        "delay": 1,
        "standard_input": 1,
        "display_standard_text": 1,
        "picture_position": 1,
        "picture_size": 1,
        "picture_size_x": 1,
        "picture_size_y": 1,
        "text_speed": 1,
        "text_animation_type": 1,
        "text_newsticker_speed": 1,
        "text_newsticker_space": 1,
        "text_newsticker_space_margin": 1,
        "interactive": 1,
    },
    'font': {
        "text_autoscale": 1,
        "text_size": 1,
        "text_family": 1,
        "text_color": 1,
        "primary_text_color": 1,
        "secondary_text_color": 1,
        "text_align": 1,
        "text_valign": 1,
        "text_decoration": 1,
        "text_style": 1,
        "text_weight": 1,
        "drop_shadow": 1,
    },
    'playback': {
        "description": 1,
        "duration": 1,
        "duration_type": 1,
        "display_runs": 1,
        "valid_from": 1,
        "valid_to": 1,
        "valid_time_from": 1,
        "valid_time_to": 1,
        "loop": 1,
        "weekdays": 1,
        "smart_loop": 1,
        "smart_loop_number": 1,
        "transition": 1,
        "transition_length": 1,
        "literal_times": 1
    },
    'hidden': {
        "alternative_background_image": 1,
        "alternative_name": 1,
        "alternative_type": 1,
        "alternative_id": 1,
        "hidden_name": 1
    }
}

export const elementsSettingsDefinition = require('../../../../../content/elementSettingsDefinitions.json');

export const elementsSettingsLimits = {
    "text": {
        "text_size": {min: 1, max: 512, empty: 1},
    },
    "default": {
        "width":                        {min: 1, max: 65536},
        "height":                       {min: 1, max: 65536},
        "loop":                         {min: 1},
        "duration":                     {min: 1},
        "display_runs":                 {min: 1},

        "elementLeft":                  {min: 0, max: "inner_max_elementLeft"},
        "elementTop":                   {min: 0, max: "inner_max_elementTop"},
        "elementWidth":                 {min: 1, max: "inner_max_elementWidth"},
        "elementHeight":                {min: 1, max: "inner_max_elementHeight"},


        "text_size":                    {min: 1, max: 512, empty: 1},
        "text_newsticker_speed":        {min: 0, max: 100, empty: 1},
        "text_newsticker_space_margin": {min: 0, max: 2000, empty: 1},
        "rss_speed":                    {min: 0, max: 100, empty: 1},
        "rss_newsticker_space_margin":  {min: 0, max: 2000, empty: 1},
        "back_transparency":            {min: 0, max: 100, empty: 1},
        "transparency":                 {min: 0, max: 100, empty: 1},
        "delay":                        {min: 0, max: 999, empty: 1, float: 1},
        "page_from":                    {min: 1, max: "page_to", fallback_min: null, fallback_max: "page_count", empty: 1},
        "page_to":                      {min: "page_from", max: "page_count", fallback_min: 1, empty: 1},

        "esign_refresh":                {min: 0, empty: 1},
        "esign_scrolling":              {min: 0, empty: 1},
        "video_volume":                 {min: 0, max: 100, empty: 1},

       // "esign_scrolling":              {min: 0, empty: 1},
        "drop_shadow":                  {min: 0, empty: 1},
        "transition_length":            {min: 0, float: 1, empty: 1},
        "interval":                     {min: 1, empty: 1},
        "smart_loop_number":            {min: 1, empty: 1},

        "secondary_color":              {min: 0, max: 0xFFFFFFFF, color: 1, empty: 1},
        "primary_color":                {min: 0, max: 0xFFFFFFFF, color: 1, empty: 1},
    }
}
